<template>
  <v-container> </v-container>
</template>

<script>
export default {
  name: 'Home',
  created() {
    this.$router.push({
      name: 'orders',
    })
  },
}
</script>
